import { render, staticRenderFns } from "./add-patients-to-group.vue?vue&type=template&id=3a44b507&scoped=true"
import script from "./add-patients-to-group.vue?vue&type=script&lang=js"
export * from "./add-patients-to-group.vue?vue&type=script&lang=js"
import style0 from "./add-patients-to-group.vue?vue&type=style&index=0&id=3a44b507&prod&lang=scss&scoped=true"
import style1 from "./add-patients-to-group.vue?vue&type=style&index=1&id=3a44b507&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a44b507",
  null
  
)

export default component.exports